<template>
    <div class="project-container">
        <div class="row">
            <div class="left">
                <span>创建时间：</span>
                <el-date-picker v-model="startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-date-picker v-model="endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="right">
                <el-input placeholder="请输入内容" v-model="searchStr" class="input-with-select" clearable>
                    <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                        <el-option label="项目名称" value="projectName"></el-option>
                        <el-option label="项目编号" value="projectNumber"></el-option>
                        <el-option label="WBS名称" value="wbsName"></el-option>
                        <el-option label="WBS编号" value="wbsNumber"></el-option>
                    </el-select>
                </el-input>
                <el-button icon="el-icon-search" type="primary" @click="getData">搜 索</el-button>
                <el-button type="primary" @click="initData">重 置</el-button>
            </div>
        </div>
        <el-button type="primary" @click="createProject" class="createBtn">创 建</el-button>
        <el-table :data="tableData" border style="width: 100%" max-height="780px" :header-cell-style="getTableHeader()"
            stripe v-loading="loadData">
            <el-table-column prop="wbsName" label="WBS名称" width="180" align="center">
            </el-table-column>
            <el-table-column prop="wbsNumber" label="WBS编号" width="180" align="center">
            </el-table-column>
            <el-table-column prop="projectName" label="项目名称" width="180" align="center">
            </el-table-column>
            <el-table-column prop="projectNumber" label="项目编号" width="180" align="center">
            </el-table-column>
            <el-table-column prop="totalAmount" label="预算总额" width="180" align="center">
            </el-table-column>
            <el-table-column prop="balance" label="预算剩余" width="180" align="center">
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
                <template slot-scope="scope">
                    <span :class="scope.row.status === 1 ? 'started' : 'not-started'">{{ scope.row.status === 1 ? '启用' :
                        '关闭' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="editRow(scope.row)">
                        查看
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 300, 500]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="WBS详情" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <el-tabs tab-position="left" class="dialog-box">
                <el-tab-pane label="基本信息">
                    <div class="box">
                        <div class="item w40">
                            <div class="label">项目名称</div>
                            <el-select v-model="baseInfo.projectId" :disabled="!canEdit" placeholder="请选择" clearable
                                @change="projectChange">
                                <el-option v-for="i in projectList" :key="i.id" :label="i.projectName" :value="i.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="item w40">
                            <div class="label">项目编号</div>
                            <div class="value">{{ baseInfo.projectNumber }}</div>
                        </div>
                        <div class="item">
                            <div class="label">WBS名称</div>
                            <ElInputTrim v-model="baseInfo.wbsName" :disabled="!canEdit" />
                        </div>
                        <div class="item">
                            <div class="label">WBS编号</div>
                            <ElInputTrim v-model="baseInfo.wbsNumber" :disabled="!canEdit" />
                        </div>
                        <div class="item">
                            <div class="label">申请时间</div>
                            <el-date-picker v-model="baseInfo.applyTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                type="date" placeholder="选择日期" :disabled="!canEdit">
                            </el-date-picker>
                        </div>
                        <div class="item w40">
                            <div class="label">预算总额</div>
                            <ElInputTrim v-model="baseInfo.totalAmount" :disabled="!canEdit" type="number"
                                @input="amountInput" />
                        </div>
                        <div class="item w40">
                            <div class="label">预算余额</div>
                            <ElInputTrim v-model="baseInfo.balance" disabled />
                        </div>
                        <div class="item w100">
                            <div class="label">预算说明</div>
                            <ElInputTrim :rows="2" type="textarea" v-model="baseInfo.describe" :disabled="!canEdit" />
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="费用明细" v-if="dialogId">
                    <div class="box shop">
                        <Editable :headerStyle="getTableHeader()" height="360" :value="costList" :header="costHeader"
                            @delRow="delRow">
                        </Editable>
                        <div class="page-block">
                            <el-pagination @size-change="handleDialogSizeChange"
                                @current-change="handleDialogCurrentChange" :current-page="dialogPage"
                                :page-sizes="[10, 20, 50, 100, 200, 300, 500]" :page-size="dialogSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="dialogTotal">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="canEdit = true" v-if="dialogId && !canEdit && baseInfo.status === 1">编
                    辑</el-button>
                <el-button type="primary" @click="submit" v-if="!dialogId || canEdit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getTableHeader, formatDate } from '../../assets/js/common.js'
import Editable from '@/components/Editable';
import { ajaxGet, ajaxPost, Baseurl } from '../../api/api/api.js';
import { mapState } from 'vuex';
import ElInputTrim from '@/components/ElInputTrim/index.vue';
export default {
    name: 'BudgetManagement',
    components: {
        Editable,
        ElInputTrim
    },
    props: {},
    data() {
        return {
            startDate: '',
            endDate: '',
            searchStr: '',
            searchType: 'projectName',
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            canEdit: false,
            tableData: [],
            baseInfo: {
                projectName: '',
                projectId: '',
                projectNumber: '',
                wbsNumber: '',
                wbsName: '',
                describe: '',
                totalAmount: '',
                balance: '',
                applyTime: '',
            },
            dialogId: null,
            costList: [],
            costHeader: [
                { prop: 'explanation', label: '费用说明' },
                { prop: 'feeType', label: '费用类型' },
                { prop: 'nature', label: '性质', type: 'input' },
                { prop: 'amount', label: '金额', type: 'input' },
                { prop: 'tradingTime', label: '使用时间', type: 'input' },
            ],
            companyOpts: [],
            shopOpts: [],
            activeShopMap: {},
            dictionaryMap: {},
            loadShop: false,
            personOpts: [],
            selectPerson: [],
            personMap: {},
            personMapInit: {}, //回显时使用
            loadData: false,
            projectList: [],
            projectMap: {},
            dialogPage: 1,
            dialogSize: 10,
            dialogTotal: 0,
        };
    },
    watch: {},
    computed: {
        ...mapState({
            role: state => state.user.role,
        })
    },

    created() {
        // this.endDate = this.formatDate(new Date().getTime());
        // this.startDate = this.endDate.substring(0, 7) + '-01';
        this.getProjectList();
    },
    mounted() {
        this.getData();
    },
    methods: {
        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        amountInput(){
            this.baseInfo.balance = this.baseInfo.totalAmount
        },
        projectChange(){
            if(this.baseInfo.projectId){
                this.baseInfo.projectNumber = this.projectMap[this.baseInfo.projectId]['projectNumber'];
                this.baseInfo.projectName = this.projectMap[this.baseInfo.projectId]['projectName'];
            }else{
                this.baseInfo.projectNumber = null;
                this.baseInfo.projectName = null;
            }
        },
        getProjectList(){
            ajaxGet(Baseurl + 'projectController/selectProjects').then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const obj = {};
                        for(let i = 0; i < res.data.length; i++){
                            obj[res.data[i]['id']] = res.data[i]
                        }
                        this.projectMap = obj;
                        this.projectList = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                }
            })
        },
        async editRow(d) {
            const row = JSON.parse(JSON.stringify(d));
            const baseInfo = {};
            for (let key in row) {
                if (typeof row[key] !== 'object' && typeof row[key] !== 'function') {
                    baseInfo[key] = row[key];
                }
            }
            await this.getCostList(row);
            this.baseInfo = baseInfo;
            this.dialogId = row.id;
            this.dialogVisible = true;
            this.canEdit = false;
        },
        async getCostList(d){
            const params = {
                wbsId: d.id,
                page: this.dialogPage,
                size: this.dialogSize,
            }
            const resp = await ajaxPost(Baseurl + 'projectCostController/selectProjectCostPageByWbsId', params)
            if (resp.status === 200) {
                const res = resp.data;
                if (res.code === 200) {
                    const data = res.data;
                    this.costList = data.list;
                    this.dialogTotal = data.total;
                } else {
                    this.costList = [];
                    this.$message.error(res.message);
                }
            }
        },
        // sellerType
        delRow(row) {
            this.costList.splice(row.$index, 1);
        },
        // 状态改变
        statusChange(row) {
            const params = {
                id: row.id,
                status: row.myStatus ? 1 : 0
            }
            ajaxPost(Baseurl + 'projectController/updateProjectStatus', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        this.$message.success('修改成功');
                        this.$set(row, 'status', params['status'])
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.loadShop = false;
            })
        },
        initData() {
            this.startDate = '';
            this.endDate = '';
            this.searchStr = '';
            this.page = 1;
            this.size = 10;
            this.searchType = 'projectName';
            this.getData();
        },
        getData() {
            this.loadData = true;
            const params = {
                "page": this.page,
                "size": this.size,
                // "startTime": this.startDate + " 00:00:00",
                // "endTime": this.endDate + " 23:59:59",
            }
            if (this.startDate) {
                params['startTime'] = this.startDate + " 00:00:00"
            }
            if (this.endDate) {
                params['endTime'] = this.endDate + " 23:59:59"
            }
            if (this.searchStr) {
                params['searchType'] = this.searchType;
                params['searchStr'] = this.searchStr;
            }
            ajaxPost(Baseurl + 'projectWbsController/selectProjectWbsPage', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const data = res.data;
                        this.tableData = data.list.map(item => {
                            return {
                                ...item,
                                myStatus: item.status === 1
                            }
                        });
                        this.total = data.total;
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.loadData = false;
            })
        },
        // 基础信息保存
        submit() {
            if (!this.baseInfo.wbsName) {
                this.$message.error('请填写WBS名称！');
                return
            }
            if (!this.baseInfo.wbsNumber) {
                this.$message.error('请填写WBS编号！');
                return
            }
            const params = {
                ...this.baseInfo,
                // createUid: this.role.uid,
            }
            let text = '新建';
            let api = 'insertProjectWbs';
            if (this.dialogId) {
                params['id'] = this.dialogId;
                text = '修改';
                api = 'updateProjectWbs'
            }
            ajaxPost(Baseurl + 'projectWbsController/' + api, params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        this.$message.success(text + '成功！');
                        this.dialogVisible = false;
                        this.clearDialogData();
                        this.getData();
                    } else {
                        this.$message.error(res.message);
                    }
                }
            })
        },
        clearDialogData() {
            this.costList = [];
            this.resourceList = [];
            this.shopList = [];
            this.dialogId = null;
            this.selectPerson = [];
            this.activeShopMap = {};
            this.baseInfo = {};
            this.canEdit = false;
            this.personMap = this.personMapInit;
        },
        handleClose() {
            this.clearDialogData();
            this.dialogVisible = false;
        },
        getTableHeader,
        handleSizeChange(val) {
            this.page = 1;
            this.size = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        handleDialogSizeChange(val) {
            this.dialogPage = 1;
            this.dialogSize = val;
            this.getData();
        },
        handleDialogCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        createProject() {
            this.canEdit = true;
            this.dialogVisible = true
        }
    },
};
</script>
<style lang="scss" scoped>
.row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left,
    .right {
        display: flex;
        align-items: center;
    }

    /deep/ .el-date-editor {
        margin: 0 5px;
    }

    .right {
        .el-button {
            margin-left: 10px;
        }

        .el-select {
            width: 120px;
        }
    }
}

.dialog-box {
    .box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;

        .item {
            width: 30%;
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .label {
                width: 80px;
            }

            .el-input,
            .el-textarea,
            .el-select,
            .value {
                flex: 1;
            }

            &.w100 {
                width: 100%;
            }
            &.w40 {
                width: 45%;
            }
        }

        &.shop {
            display: block;

            .select-box {
                display: flex;

                .select-item {
                    display: flex;
                    align-items: center;
                    margin-right: 10px;

                    .select-label {
                        margin-right: 5px;
                    }

                    .el-select {
                        width: 250px;

                        &.w800 {
                            width: 800px;
                        }
                    }
                }
            }
        }
    }
}

/deep/ .el-tabs__content {
    max-height: 500px;
}

.el-tab-pane {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: auto;

    .editable-container {
        width: 100%;
    }

    .box {
        width: 100%;
        max-height: 465px;
        overflow: auto;
    }

    .last-button {
        margin-top: 5px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

.started {
    background-color: #70b603;
    color: #fff;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}

.not-started {
    background-color: #f5f5f5;
    color: #999;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}

.page-block {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.createBtn {
    margin: 10px 0;
}
</style>